<template>
  <FormSection
    class="app-video-shots"
    :title="$t('APP.MEDIA.VIDEO_SHOTS')"
    :is-edit-mode="editable"
    :description="$t('APP.MEDIA.VIDEO_SHOTS_DESC')"
    has-edit
    @edit="editable = true"
  >
    <Card v-loading="loading" :hide-overflow="false">
      <ElForm
        ref="videoShots"
        :model="videoShotsModel"
        :rules="videoShotsRules"
        label-position="top"
        @submit.native.prevent="saveVideoShots"
      >
        <div v-show="editable">
          <ElFormItem :label="$t('APP.MEDIA.VIDEO_SHOTS_URL_FA')" prop="url_fa">
            <ElInput
              v-model="videoShotsModel.url_fa"
              name="url_fa"
              dir="ltr"
              class="text-latin"
            />
          </ElFormItem>

          <ElFormItem :label="$t('APP.MEDIA.VIDEO_SHOTS_URL_EN')" prop="url_en">
            <ElInput
              v-model="videoShotsModel.url_en"
              name="url_en"
              dir="ltr"
              class="text-latin"
            />
          </ElFormItem>

          <ErrorsList
            v-if="videoShotsFormErrors"
            :errors="videoShotsFormErrors"
          />

          <div class="flex-container align-justify">
            <div>
              <ElButton
                type="primary"
                :disabled="loading"
                native-type="submit"
                size="large"
              >
                {{ $t('SAVE') }}
              </ElButton>

              <ElButton type="text" @click.native="editable = false">
                {{ $t('CANCEL') }}
              </ElButton>
            </div>

            <div>
              <ElButton
                type="danger"
                size="large"
                icon="el-icon-delete"
                plain
                :disabled="loading"
                @click="deleteVideoShots"
              />
            </div>
          </div>
        </div>

        <div v-show="!editable">
          <dl class="list list--definition list--clean">
            <dt>{{ $t('APP.MEDIA.VIDEO_SHOTS_URL_FA') }}</dt>
            <dd dir="ltr" class="text-latin">
              <a
                rel="noreferrer"
                :href="videoShots.url_fa"
                target="_blank"
                class="link"
              >
                {{ videoShots.url_fa }}
              </a>
            </dd>

            <dt>{{ $t('APP.MEDIA.VIDEO_SHOTS_URL_EN') }}</dt>
            <dd dir="ltr" class="text-latin">
              <a
                v-if="videoShots.url_en"
                rel="noreferrer"
                :href="videoShots.url_en"
                target="_blank"
                class="link"
              >
                {{ videoShots.url_en }}
              </a>
              <span v-else>ـ</span>
            </dd>
          </dl>
        </div>
      </ElForm>
    </Card>
  </FormSection>
</template>

<script>
import ErrorsList from '@@/common/ErrorsList';
import FormSection from '@@/common/layout/FormSection';
import Card from '@@/common/Card';
import { Apps } from '@/api/api';

import { APP_DETAILS } from '@/store/types';

import form from '@/mixins/form';
import packageNameMixin from '@/mixins/packageName';
import packageNameWatch from '@/mixins/apps/packageNameWatch';
import { mapGetters } from 'vuex';

export default {
  name: 'AppVideoShots',
  components: {
    ErrorsList,
    FormSection,
    Card,
  },
  mixins: [form, packageNameMixin, packageNameWatch],
  data() {
    return {
      videoShots: {
        url_fa: '',
        url_en: '',
      },
      videoShotsModel: {
        url_fa: '',
        url_en: '',
      },
      editable: false,
      loading: false,
      videoShotsFormErrors: null,
    };
  },
  computed: {
    ...mapGetters({ app: APP_DETAILS }),
    videoShotsRules() {
      const aparatURLRule = {
        pattern: /^(https?:\/\/)?(www\.)?aparat\.com\/v\/(?:\w+\/?)+$/i,
        message: this.$t('APP.MEDIA.INVALID_APARAT_URL'),
      };

      return {
        url_fa: aparatURLRule,
        url_en: aparatURLRule,
      };
    },
  },

  created() {
    this.getInfo();
  },

  methods: {
    getInfo() {
      this.getVideoShots();
    },

    getVideoShots() {
      return Apps.getVideoShots({ packageName: this.packageName })
        .then(({ body: { video_shots: shots } }) => {
          const videoShots = {
            url_fa: shots.url_fa,
            url_en: shots.url_en,
          };
          this.videoShots = videoShots;
          this.videoShotsModel = { ...videoShots };
        })
        .catch(({ body: { message } = {} }) => {
          if (message) {
            this.$message.error(message);
          }
        });
    },
    deleteVideoShots() {
      return this.updateVideoShots({ url_fa: '', url_en: '' });
    },
    saveVideoShots() {
      if (!this.isValid('videoShots')) {
        return false;
      }

      return this.updateVideoShots(this.videoShotsModel);
    },
    updateVideoShots(videoShots) {
      this.loading = true;
      const params = { packageName: this.packageName };

      return Apps.updateVideoShots(params, videoShots)
        .then(({ body: { message } }) => {
          this.videoShots = { ...videoShots };
          this.$message.success(message);
        })
        .then(() => {
          this.editable = false;
          this.videoShotsFormErrors = null;
        })
        .catch(({ body: { message, errors } = {} }) => {
          if (message) {
            this.$message.error(message);
          }

          if (errors) {
            this.videoShotsFormErrors = errors;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="scss">
.app-video-shots {
  input {
    font-family: $lb-body-en-font-family;
  }
}
</style>
